<template>
  <div class="Finance">
    <navigator :title="serviceMsg.serviceName" :routePath='"/"'></navigator>
    <div class="content">
      <div class="boxBig" v-for="(item, index) in financeList" :key="index" @click="detalis(item.serviceId)">
        <img :src="item.picUrl" alt="" class="img_b">
        <div class="title textOver">
          {{item.serviceName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigator from '@/components/Navigator';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return{
      financeList: [],
      serviceMsg: {},
    }
  },
  methods: {
    detalis(id) {
      this.$router.push({ path: `/financeDetalis/${id}` });
    },
    getList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/park/service/list`,{
        parentId: this.serviceMsg.serviceId,
        parkId: this.currentParkId,
      }).then((res) => {
        if(res.data.resCode === '10000') {
          this.financeList = res.data.resData.pageList;
        }
      });
    },
  },
  components: {
    Navigator,
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'parkServiceList']),
  },
  created() {
    this.serviceMsg = this.parkServiceList.find((val) => {
      return val.serviceFlag === 4;
    });
    this.getList();
  },
}
</script>

<style lang="scss" scoped>
  @import "~@scss";
.Finance{
  background-color: rgb(245, 245, 245);
  min-height: 100%;
}
.content{
  .boxBig{
    background-color: #fff;
    width: 9.36rem;
    border-radius: .106667rem;
    margin: px2rem(24) px2rem(24) 0 px2rem(24);
    .img_b{
      width: 100%;
      height: 5.253333rem;
      display: inline-block;
      border-radius: .106667rem .106667rem 0 0;
      border-bottom: 1px solid #c4c4c4;
    }
    .title{
      flex: 1;
      padding: .32rem;
      font-size: .453333rem;
      font-weight: bold;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/finance/Finance.vue